import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=04d93803&scoped=true"
import script from "./AuthLayout.vue?vue&type=script&lang=ts"
export * from "./AuthLayout.vue?vue&type=script&lang=ts"
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=04d93803&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d93803",
  null
  
)

export default component.exports